import React from 'react';
import { DataGrid, GridToolbar, useGridApiRef } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';

const DataTable = ({
  rows,
  columns,
  title,
  searchPlaceholder = "Search...",
  onRowDoubleClick,  // Accepts custom onRowDoubleClick handler
  searchComponent,  // Accepts a custom search component
  headerActions,  // Accepts action buttons for the header
  ...rest  // Allows passing additional props
}) => {
  const apiRef = useGridApiRef();
  return (
    <Box sx={{ padding: { xs: '10px', sm: '20px' }, backgroundColor: '#f5f7fb', marginTop: '90px' }}>
      {/* Header Section */}
      <Box
        component="header"
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          marginBottom: '20px',
          padding: { xs: '15px', sm: '10px 20px' },
          borderRadius: '10px',
          backgroundColor: '#fff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          gap: { xs: 2, sm: 0 }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '5px' }}>
          <GroupIcon sx={{ fontSize: { xs: '32px', sm: '40px' }, color: '#003366' }} />
          <Box component="h2" sx={{ margin: 0, padding: 0, fontSize: { xs: '1.25rem', sm: '1.5rem' }, color: '#003366', fontWeight: 'bold' }}>{title}</Box>
        </Box>
        {headerActions && (
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1, sm: 2 },
            width: { xs: '100%', sm: 'auto' }
          }}>
            {headerActions}
          </Box>
        )}
      </Box>

      {/* Search Bar Section */}
      {searchComponent && (
        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          marginBottom: '10px',
          paddingLeft: { xs: '10px', sm: '20px' }
        }}>
          {searchComponent}
        </Box>
      )}

      {/* Table Section */}
      <Box
        sx={{
          height: '65vh',
          backgroundColor: '#fff',
          borderRadius: '10px',
          padding: { xs: '10px', sm: '20px' },
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <DataGrid
          apiRef={apiRef}
          rows={rows}
          columns={columns}
          onRowDoubleClick={onRowDoubleClick} // Only double-click handler is functional now
          slots={{toolbar:GridToolbar}}
          slotProps={{toolbar: {printOptions: {disableToolbarButton: true}}}}
          localeText={{
            toolbarFilters: 'FILTER',
            toolbarFiltersLabel: 'Show filter',
            toolbarFiltersTooltipShow: 'Show filter',
            toolbarFiltersTooltipHide: 'Hide filter'
          }}
          sx={{
            '.MuiDataGrid-columnHeaders': {
              bgcolor: 'rgba(6, 14, 118, 0.08)',
              minHeight: '40px !important',
              maxHeight: '40px !important',
            },
            '.MuiDataGrid-columnHeader': {
              bgcolor: 'rgba(6, 14, 118, 0.08)',
              position: 'sticky',
              padding: '0 8px',
              minHeight: '40px !important',
              maxHeight: '40px !important',
            },
            '.MuiDataGrid-columnHeaderTitle': {
              fontSize: '0.875rem',
              fontWeight: 600,
            },
            '& .MuiDataGrid-filler': {
              bgcolor: 'rgba(6, 14, 118, 0.08)',
            },
          }}
          {...rest} // Ensures any additional props are passed to DataGrid
        />
      </Box>
    </Box>
  );
};

export default DataTable;
